
import { defineComponent, ref } from 'vue'

export default defineComponent({
    name: 'billing-templates-form-field-payment-terms',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Number,
            required: true
        }
    },
    setup (props) {
        const localValue = ref(props.modelValue === 0 ? null : props.modelValue)
        return { localValue }
    }
})
